import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { CreateChancel, CustomizedSwitch, EditWithIcon, InputMain, SimpleTooltip } from 'components';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { systemItemStyles } from './styles';
import { ConnectAvaility } from './modals';
import { AvailityGuide } from './guide';
import { clearHouseTypeEnums, DISCONNECT_INTEGRATION_ACTION_TYPE, EDIT_INTEGRATION_ACTION_TYPE } from './constants';

export const Availity = () => {
    const { handleSubmit, control, reset } = useForm();
    const [editAvaility, setEditAvaility] = useState(false);
    const availity = useSelector((state) => state.system.systemIntegrations)?.availity;
    const classes = systemItemStyles();
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(EDIT_INTEGRATION_ACTION_TYPE);
    const success = FindSuccessItem(EDIT_INTEGRATION_ACTION_TYPE);
    const successDisconnect = FindSuccessItem(DISCONNECT_INTEGRATION_ACTION_TYPE);
    const [connect, setConnect] = useState(false);
    const [guideOpen, setGuideOpen] = useState(false);
    const [sftpPollingEnabled, setSftpPollingEnabled] = useState(false);
    const [automationPaymentEnabled, setAutomationPaymentEnabled] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
    });

    const resetData = () => {
        setConnect(availity?.isActive);
        setSftpPollingEnabled(availity?.sftpPollingEnabled);
        setAutomationPaymentEnabled(!!availity?.automationPaymentEnabled);
        const params = {
            ...availity,
        };
        delete params.id;
        delete params.isActive;
        reset(params);
    };

    useEffect(() => {
        if (availity?.id) {
            resetData();
        }
    }, [availity]);

    useEffect(() => {
        if (success) {
            setEditAvaility(false);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_INTEGRATION_ACTION_TYPE));
        }
        if (successDisconnect) {
            setEditAvaility(false);
            reset({});
            dispatch(httpRequestsOnSuccessActions.removeSuccess(successDisconnect));
        }
    }, [success, successDisconnect]);

    const handleCreate = (data) => {
        dispatch(
            systemActions.editIntegration({
                availity: {
                    ...data,
                    sftpPollingEnabled: sftpPollingEnabled,
                    automationPaymentEnabled: automationPaymentEnabled,
                },
                clearinghouseType: clearHouseTypeEnums.AVAILITY,
            })
        );
    };

    const handleSetCalendarStatus = () => {
        setConnect(!connect);
        dispatch(systemActions.disconnectIntegration(!connect, clearHouseTypeEnums.AVAILITY));
    };

    const toggleShowPassword = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <div className="office-ally-box">
            <div className="space-between" style={{ padding: 16 }}>
                <div className={classes.iconAndTitle}>
                    <img src={Images.availity} alt="availity" />
                    <div className="integration-title-block">
                        <p className="integration-title-text">Availity</p>
                        {/*{!availity?.id && (*/}
                            <button type="button" className="setup-guide-btn" onClick={() => setGuideOpen(true)}>
                                <img src={Images.setupGuide} alt="setupGuide" />
                                Setup guide
                            </button>
                        {/*)}*/}
                    </div>
                </div>
                {availity?.id ? (
                    <div className={classes.iconAndTitle} style={{ gap: 16, height: 32 }}>
                        {!editAvaility && <EditWithIcon handleClick={() => setEditAvaility(!editAvaility)} />}
                        <SimpleTooltip title={<p>{'Disconnect Office Ally'}</p>} placement="top-start">
                            <CustomizedSwitch checked={connect} handleClick={handleSetCalendarStatus} />
                        </SimpleTooltip>
                    </div>
                ) : (
                    <button onClick={() => open(<ConnectAvaility />)} className={classes.connectBtn}>
                        Connect
                    </button>
                )}
            </div>

            {editAvaility && availity?.id && (
                <div className="edit-office-ally-connection">
                    <form onSubmit={handleSubmit(handleCreate)}>
                        <p className="connection-type-title">Availity Credentials</p>
                        <div style={{ gap: 16, borderBottom: '1px solid #E4E7EC', marginBottom: 20, paddingBottom: 16 }}>
                            <div className="flex-align-center" style={{ gap: 16 }}>
                                <InputMain
                                    label={'Username*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="username"
                                    type="text"
                                    control={control}
                                    placeholder="Enter username"
                                    rules={{
                                        required: 'Username is required.',
                                    }}
                                />
                                <InputMain
                                    label={'Password*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="password"
                                    type="password"
                                    showPassword={showPassword?.password}
                                    control={control}
                                    placeholder="Enter password"
                                    rules={{
                                        required: 'Password is required.',
                                    }}
                                    onClickIconEnd={() => toggleShowPassword('password')}
                                />
                            </div>

                            {/*<div className="flex-align-center"*/}
                            {/*     style={{ gap: 16, borderBottom: '1px solid #E4E7EC', marginBottom: 20 }}>*/}
                            {/*    <InputMain*/}
                            {/*        label={'Sender Name'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="senderName"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Sender Name"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Sender Name is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*    <InputMain*/}
                            {/*        label={'Sender Id'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="senderId"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Sender Id"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Sender Id is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*    <InputMain*/}
                            {/*        label={'Receiver Name'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="receiverName"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Receiver Name"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Receiver Name is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*</div>*/}

                            {/*<div className="flex-align-center"*/}
                            {/*     style={{ gap: 16, borderBottom: '1px solid #E4E7EC', marginBottom: 20 }}>*/}
                            {/*    <InputMain*/}
                            {/*        label={'Receiver Id'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="receiverId"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Receiver Id"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Receiver Id is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*    <InputMain*/}
                            {/*        label={'Application'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="application"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Application"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Application is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*    <InputMain*/}
                            {/*        label={'Api Kay'}*/}
                            {/*        customClass={true}*/}
                            {/*        variant="outlined"*/}
                            {/*        name="apiKay"*/}
                            {/*        type="text"*/}
                            {/*        control={control}*/}
                            {/*        placeholder="Enter Api Kay"*/}
                            {/*        // rules={{*/}
                            {/*        //     required: 'Api Kay is required.',*/}
                            {/*        // }}*/}
                            {/*    />*/}
                            {/*</div>*/}

                            <div className="flex-align-start" style={{ gap: 4 }}>
                                <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                                <p className="files-sftp-folder">
                                    Files in the configured SFTP folder may be processed, moved, archived, or deleted automatically by
                                    TherapyLake.
                                </p>
                                <CustomizedSwitch
                                    checked={sftpPollingEnabled}
                                    handleClick={() => setSftpPollingEnabled(!sftpPollingEnabled)}
                                />
                            </div>

                            <div className="flex-align-start" style={{ gap: 4, marginTop: 8 }}>
                                <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                                <p className="files-sftp-folder">
                                    Automatically create payments from ERA (835) files.
                                </p>
                                <CustomizedSwitch checked={automationPaymentEnabled} handleClick={() => setAutomationPaymentEnabled(!automationPaymentEnabled)} />
                            </div>
                        </div>

                        <div style={{ marginTop: 12 }}>
                            <CreateChancel
                                justifyContent={'flex-end'}
                                type="submit"
                                loader={!!loader.length}
                                create={'Save'}
                                chancel={'Cancel'}
                                onClose={() => {
                                    resetData();
                                    setEditAvaility(false);
                                    // const params = {
                                    //     ...availity,
                                    // };
                                    // delete params.id;
                                    // delete params.isActive;
                                    // reset(params);
                                }}
                                buttonWidth={'100px'}
                            />
                        </div>
                    </form>
                </div>
            )}
            {/*</div>*/}

            <AvailityGuide open={guideOpen} onClose={() => setGuideOpen(false)} />
        </div>
    );
};
